export default "__VITE_ASSET__1990b15d__"